'use strict';

var SoaModel = require('bunsen/models/SoaModel.js');
var ends = require('dibs-endpoints');
var _ = require('underscore');

/**
 * Mailer model is sed to add an item to the mailer or remove an item from the mailer
 * @extends SoaModel
 */
var Mailer = SoaModel.extend({
    initialize: function(attrs, options) {
        options = options || {};
        Mailer.__super__.initialize.call(this, attrs, options);
        this.itemId = options.itemId;
    },
    url: function() {
        console.assert(this.itemId, 'Mailer requires itemId to generate URL');
        return ends.mailer(this.itemId);
    },
    add: function(options) {
        return this.save({ inMailer: 'Y' }, _.extend({ type: 'PUT' }, options));
    },
    remove: function(options) {
        return this.save({ inMailer: 'N' }, _.extend({ type: 'PUT' }, options));
    }
});

module.exports = Mailer;



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/inventory/Mailer.js
// module id = 2046
// module chunks = 62